import React from 'react';
import { validationSection } from '../data/mock';
import { Check } from 'lucide-react';

const ValidationSection = () => {
  return (
    <section className="w-full bg-[#e8f4f8] py-0">
      <div className="flex flex-col lg:flex-row">
        {/* Image */}
        <div className="lg:w-1/2 flex items-center justify-center p-4 lg:p-8">
          <img
            src="https://customer-assets.emergentagent.com/job_prysm-replica/artifacts/whiq30pe_Screenshot%202025-12-16%20141404.jpg"
            alt="15 Seconds Can Change Your Life"
            className="w-full h-auto max-h-[500px] rounded-lg shadow-xl object-contain"
          />
        </div>

        {/* Content */}
        <div className="lg:w-1/2 flex items-center">
          <div className="px-8 md:px-12 lg:px-16 py-12 lg:py-16">
            <h2 className="font-serif text-2xl md:text-3xl text-gray-900 mb-8 italic">
              {validationSection.title}
            </h2>
            <div className="space-y-6">
              {validationSection.points.map((point, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="flex-shrink-0 mt-1">
                    <Check size={20} className="text-gray-600" strokeWidth={1.5} />
                  </div>
                  <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                    {point}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValidationSection;
